import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const clientes = [
  {
    nome: 'Santa Casa de Itu',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/1d7c1f36abb22ac55b589f8edc60a7be.png',
  },
  {
    nome: 'Porto Pedras',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/0efcfed19a0c4c64677efcb82b8df323.png',
  },
  {
    nome: 'Padaria & Restaurante São João',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/f0021258ef461b8ebaa1153679b58a08.png',
  },
  {
    nome: 'Grupo SLA',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/88d5a825193bf4464c0dbcc506cd1103.png',
  },
  {
    nome: 'Monções Pizzaria',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/2a4b10b9d9abade92a4951aee90bb1c7.png',
  },
  {
    nome: 'Novo Cliente',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/2aceeab63d2df3713ec94ae750885451.png',
  },
  {
    nome: 'Eco Pack',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/f0c7c423ee2e05e9d631eb3e097305c4.png',
  },
  {
    nome: 'Prefeitura Municipal de Porto Feliz',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/b527bf86ae462e46ba1b62a3a36e959c.png',
  },
  {
    nome: 'iPortoFeliz Gestão Imobiliária',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/46340334be877c0df7c91fcbd4d31ef4.png',
  },
  {
    nome: 'PUPBRAS',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/8f0e7490621cf3f85f599f561c33bc1a.png',
  },
  {
    nome: 'Starrett',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/07f1ddf27e049cba2d6f0817d62b48dc.png',
  },
  {
    nome: 'Nagel',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/cd1d02a1b736803647fc6466e1525210.png',
  },
  {
    nome: 'Colégio Activo Salto',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/9f1378fd3e33d53f71e98db1ed48dd1c.png',
  },
  {
    nome: 'Associação Monte Carmelo',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/60edeab3383b8a6c0ca24c4be14a3117.png',
  },
  {
    nome: 'Titana',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/207afc1d605f5aef699266b632dc15a5.png',
  },
  {
    nome: 'ACLPZ',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/1deee73a318000f832d31ff77185daf5.png',
  },
  {
    nome: 'Délli Decor Móveis e Colchões',
    logo: 'https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/8022633561250e55066d35d05bb0ed66.png',
  },
];

const segmentos = [
  { emoji: '🏢', label: 'Condomínios' },
  { emoji: '🏭', label: 'Indústrias' },
  { emoji: '🏬', label: 'Comércios' },
  { emoji: '🏥', label: 'Hospitais e Clínicas' },
  { emoji: '🏫', label: 'Escolas' },
  { emoji: '⛪', label: 'Igrejas' },
  { emoji: '🏛️', label: 'Órgãos Públicos' },
];

const ClientesSection = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<number>(0);
  const positionRef = useRef<number>(0);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const speed = 0.5;

    const animate = () => {
      positionRef.current -= speed;
      const totalWidth = track.scrollWidth / 2;
      if (Math.abs(positionRef.current) >= totalWidth) {
        positionRef.current = 0;
      }
      track.style.transform = `translateX(${positionRef.current}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  const handleMouseEnter = () => cancelAnimationFrame(animationRef.current);

  const handleMouseLeave = () => {
    const track = trackRef.current;
    if (!track) return;
    const speed = 0.5;
    const animate = () => {
      positionRef.current -= speed;
      const totalWidth = track.scrollWidth / 2;
      if (Math.abs(positionRef.current) >= totalWidth) {
        positionRef.current = 0;
      }
      track.style.transform = `translateX(${positionRef.current}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };
    animationRef.current = requestAnimationFrame(animate);
  };

  const duplicated = [...clientes, ...clientes];

  return (
    <section className="bg-[#F8F7F4] py-12 lg:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 mb-10 lg:mb-14">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="inline-block bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-xs lg:text-sm font-semibold mb-3 lg:mb-4">
            Empresas que Confiam na Engeporto
          </div>
          <h2 className="font-display font-bold text-2xl lg:text-4xl text-[#0A1628] mb-3 lg:mb-4">
            Nossos Clientes
          </h2>
          <p className="text-gray-500 text-sm lg:text-base max-w-xl mx-auto leading-relaxed">
            Atendemos empresas de todos os portes e segmentos, incluindo condomínios, indústrias, comércios, hospitais, escolas, igrejas e órgãos públicos, oferecendo soluções técnicas personalizadas com segurança e conformidade normativa.
          </p>
        </motion.div>
      </div>

      {/* Carrossel */}
      <div
        className="relative w-full overflow-hidden"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Gradiente esquerda */}
        <div className="absolute left-0 top-0 h-full w-12 lg:w-24 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, #F8F7F4, transparent)' }}
        />
        {/* Gradiente direita */}
        <div className="absolute right-0 top-0 h-full w-12 lg:w-24 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, #F8F7F4, transparent)' }}
        />

        <div
          ref={trackRef}
          className="flex items-center gap-4 lg:gap-8 will-change-transform"
          style={{ width: 'max-content' }}
        >
          {duplicated.map((cliente, index) => (
            <div
              key={`${cliente.nome}-${index}`}
              className="flex-shrink-0 w-48 h-28 lg:w-64 lg:h-36 bg-white rounded-xl border border-gray-100 shadow-sm flex items-center justify-center px-4 lg:px-6 hover:shadow-md hover:border-[#D4AF37]/30 transition-all cursor-default"
              title={cliente.nome}
            >
              <img
                src={cliente.logo}
                alt={`Logo ${cliente.nome}`}
                className="max-w-full max-h-20 lg:max-h-28 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Segmentos Atendidos */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="max-w-7xl mx-auto px-4 lg:px-8 mt-10 lg:mt-14"
      >
        <p className="text-center text-xs uppercase tracking-widest text-gray-400 font-semibold mb-6">
          Principais Segmentos Atendidos
        </p>
        <div className="flex flex-wrap justify-center gap-3 lg:gap-4">
          {segmentos.map((seg) => (
            <div
              key={seg.label}
              className="flex items-center gap-2 bg-white border border-gray-100 shadow-sm rounded-full px-4 py-2 hover:border-[#D4AF37]/40 hover:shadow-md transition-all cursor-default"
            >
              <span className="text-xl leading-none">{seg.emoji}</span>
              <span className="text-xs lg:text-sm font-medium text-[#0A1628] whitespace-nowrap">{seg.label}</span>
            </div>
          ))}
        </div>
      </motion.div>

      {/* Contador de clientes */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="max-w-7xl mx-auto px-4 lg:px-8 mt-10 lg:mt-14"
      >
        <div className="flex flex-wrap justify-center gap-8 lg:gap-20">
          {[
            { number: '80+', label: 'Clientes Ativos' },
            { number: '15+', label: 'Segmentos Atendidos' },
            { number: '100%', label: 'Conformidade Técnica' },
          ].map((item) => (
            <div key={item.label} className="text-center">
              <div className="font-display font-bold text-3xl lg:text-4xl text-[#D4AF37] mb-1">{item.number}</div>
              <div className="text-[10px] lg:text-xs uppercase tracking-widest text-gray-500 font-semibold">{item.label}</div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default ClientesSection;
